import { ContenuCtaVideo } from '@components/contenu-cta-video/models';
import { videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const contenuCtaVideoMock = (backgroundColor: 'gray' | 'white' = 'white'): Block<ContenuCtaVideo> => ({
  type: 'contenu-cta-video',
  data: {
    title: {
      text: `Je personnalise [[ma cuisine]]`,
      as: 'span',
    },
    text: `La recette pour une cuisine bien équipée tient dans le choix de ses ingrédients. Plans de travail, façades, meubles : concoctez votre cuisine selon vos envies !`,
    ctaOne: {
      label: `Voir tous les meubles`,
      url: '/mock-voir-tous-les-meubles',
    },
    ctaTwo: {
      label: `Voir toutes les finitions`,
      url: '/mock-voir-toutes-les-finitions',
    },
    video: videoMock(),
    background: backgroundColor,
  },
});
